import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  entityPlusData: null,
  status: "idle",
  error: null,
};

const entityPlusSlice = createSlice({
  name: "entityPlus",
  initialState,
  reducers: {
    resetEntityPlusData: (state) => {
      state.entityPlusData = null;
      state.status = "idle";
      state.error = null;
    },
  },
});

export const { resetEntityPlusData } = entityPlusSlice.actions;
export default entityPlusSlice.reducer;
